// extracted by mini-css-extract-plugin
export var closeButton = "_40-0";